import styled from 'styled-components';

/** Shared multi-line description input used by both the Generate and Improve forms. */
export const DescriptionInput = styled.textarea`
  outline: none;
  width: 100%;
  min-height: 160px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  padding: 12px 16px;
  resize: vertical;
`;
